import "./PendingChangesPanel.scss";
import { Header } from "../StickyTable";
import { MdArrowDownward } from "react-icons/md";
import { RowType } from "./pendingChangesUtils";
import * as R from "ramda";
import React from "react";

interface PendingEditedRowProps<R> {
  columns: Header[];
  newRow: R;
  oldRow: R;
  pendingRowHeaderRender?: (row: R) => JSX.Element;
}

const PendingEditedRow = <R extends RowType>({
  columns,
  newRow,
  oldRow,
  pendingRowHeaderRender,
}: PendingEditedRowProps<R>): JSX.Element => {
  return (
    <div className="pendingChangesRowContainer pendingEditRowContainer">
      {pendingRowHeaderRender && (
        <div className="pendingChangesRowTitle">{pendingRowHeaderRender(oldRow)}</div>
      )}
      {columns.map(col => {
        const { label, field, renderer } = col;
        const oldVal = oldRow[field || ""] || "null";
        const newVal = newRow[field || ""] || "null";
        return (
          <div key={label}>
            {!R.equals(oldVal, newVal) ? (
              <div className="pendingChangesRow">
                <b className="pendingChangesRowLabel">{label}:</b>
                <div className="pendingChangesRowVal">
                  <div className="oldVal">{renderer ? renderer(oldRow) : oldVal}</div>
                  <div className="pendingChangesArrow">
                    <MdArrowDownward />
                  </div>
                  <div className="newVal">{renderer ? renderer(newRow) : newVal}</div>
                </div>
              </div>
            ) : (
              <div className="pendingChangesRow">
                <b className="pendingChangesRowLabel">{label}:</b>
                <div>{renderer ? renderer(newRow) : newVal}</div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default PendingEditedRow;
